import $ from 'jquery';
import { DisableTargetOnValue } from '../components/disable-target-on-value';
import { DisableOnTargetValue } from '../components/disable-on-target-value';
import CustomerDeviceModal from './customer-device-modal';
import { SoftValidationMessages } from '../components/soft-validation-messages';
import NegativeInput from '../components/negative-input';
import { SumFieldValues } from '../components/sum-field-values';

const Collection = (() => {
  const $addTagButtonBase = $(
    '<a href="#" class="ui icon primary button js__add-button"><i class="plus icon"></i></a>',
  );
  const $removeTagButtonBase = $(
    '<a href="#" class="ui icon danger button js__remove-button"><i class="minus icon"></i></a>',
  );
  const $newLinkLiBase = $('<li class="buttons js__buttons"></li>');

  const removeTagForm = ($collectionHolder, elementIndex = null) => {
    if (elementIndex !== null) {
      $collectionHolder.find('li').get(elementIndex).remove();
    } else {
      $collectionHolder.find('li').last().prev().remove();
    }
  };

  function bindImageLazyLoading($images, $context) {
    $images.visibility({
      type: 'image',
      transition: 'fade in',
      duration: 1000,
      once: false,
      context: $context,
      observeChanges: true,
      throttle: 1000,
    });
  }

  function onDropdownClick(event) {
    const $dropdown = $(this);

    setTimeout(() => {
      bindImageLazyLoading($dropdown.find('img.ui.image'), $dropdown.find('.menu'));
      $(this).off(event);
    }, 1000);
  }

  const bindDropdowns = $dropdowns => {
    $dropdowns.dropdown({
      fullTextSearch: true,
    });

    setTimeout(() => {
      bindImageLazyLoading($dropdowns.find('.text img.ui.image'), window);
    }, 1000);
    $dropdowns.on('click', onDropdownClick);
  };

  function collectionItemRemoveAction($collectionHolder, $button) {
    if ($collectionHolder.data('delete-button-on-every-item')) {
      const elementIndex = $button.closest('.js__collection-item').index();
      removeTagForm($collectionHolder, elementIndex);
    } else {
      removeTagForm($collectionHolder);
    }
    SumFieldValues.init();
  }

  const addTagForm = ($collectionHolder, $newLinkLi) => {
    const prototype = $collectionHolder.data('prototype');
    const index = $collectionHolder.data('index');
    let newForm = prototype;

    newForm = newForm.replace(/__name__/g, index);

    $collectionHolder.data('index', index + 1);

    const $newFormLi = $('<li class="js__collection-item"></li>').append(newForm);
    if ($collectionHolder.data('delete-button-on-every-item')) {
      const $deleteButton = $removeTagButtonBase.clone();
      $newFormLi.append($deleteButton);
      $deleteButton.on('click', e => {
        e.preventDefault();

        collectionItemRemoveAction($collectionHolder, $(e.currentTarget));
      });
    }
    $newLinkLi.before($newFormLi);
    const $newFormDropdowns = $newFormLi.find('.search-select');
    $newFormDropdowns.dropdown({ fullTextSearch: true });
    bindDropdowns($newFormDropdowns);
    $newFormLi.find('.ui.checkbox').checkbox();
    $newFormLi.find('.js__init-ajax-select').each((index, element) => {
      $(element).ajaxInput();
    });
    DisableTargetOnValue.init($newFormLi);

    $newFormLi.find('.js__init-modal').on('click', ({ currentTarget }) => {
      const deviceParent = $(currentTarget).closest('.js__set-device-value');
      $('.js__device-modal').customerDeviceModal(deviceParent);
    });

    const $orderProductType = $newFormLi.find('.js__order-product-type-toggle');

    $orderProductType.on('change', () => {
      const $item = $orderProductType.dropdown('get item');
      if (!$item) {
        return;
      }
      const bundleVariantsUrl = $item.data('bundle');
      if (typeof bundleVariantsUrl !== 'undefined') {
        $orderProductType.addClass('disabled loading');
        $.get(bundleVariantsUrl)
          .fail(() => console.log('error'))
          .done(result => {
            $newFormLi.find('.js__order-product-type-target').replaceWith(result);
            $newFormLi.find('.js__order-product-type-target').find('input').trigger('change');
            $newFormLi.find('.js__order-product-type-target').find('.search-select').dropdown({ fullTextSearch: true });
          })
          .always(() => $orderProductType.removeClass('disabled loading'));
      } else {
        $newFormLi.find('.js__order-product-type-target').empty();
      }
    });
  };

  const init = () => {
    const $collectionHolders = $('ul.items');
    bindDropdowns($('.search-select'));

    $collectionHolders.each((key, collectionHolder) => {
      const $collectionHolder = $(collectionHolder);

      if (!$collectionHolder.data('prototype')) {
        return;
      }
      const isE2eEnabled = !!$collectionHolders.data('e2e-id');
      const $addTagButton = $addTagButtonBase.clone();
      const $removeTagButton = $removeTagButtonBase.clone();
      if (isE2eEnabled) {
        $addTagButton.attr('data-e2e-id', 'add-collection');
        $removeTagButton.attr('data-e2e-id', 'remove-collection');
      }

      let $newLinkLi = null;

      if ($collectionHolder.data('delete-button-on-every-item')) {
        $newLinkLi = $newLinkLiBase.clone().append($addTagButton);
      } else {
        $newLinkLi = $newLinkLiBase.clone().append($addTagButton).append($removeTagButton);
      }

      $collectionHolder.data('index', $collectionHolder.find('li').length);

      if (!$collectionHolder.closest('.js__hide-action-buttons').length) {
        if ($collectionHolder.data('delete-button-on-every-item')) {
          $collectionHolder.find('li').each((index, element) => {
            $(element).append($removeTagButton.clone());
          });
        }
        $collectionHolder.append($newLinkLi);
      }

      $addTagButton.on('click', e => {
        e.preventDefault();

        addTagForm($collectionHolder, $newLinkLi);
        $('.ui.checkbox').checkbox();
        const $prototypeContainer = $collectionHolder.find('.js__prototype-container');
        const $newCollectionContainer = $prototypeContainer.length ? $prototypeContainer.last() : $('body');
        DisableOnTargetValue.init($newCollectionContainer);
        SoftValidationMessages.init($newCollectionContainer);
        CustomerDeviceModal.init();
        $('.js__init-ajax-select').each((index, element) => {
          $(element).ajaxInput();
        });
        NegativeInput.init($newCollectionContainer);
        SumFieldValues.init();
      });

      $collectionHolder.find('.js__remove-button').on('click', e => {
        e.preventDefault();

        collectionItemRemoveAction($collectionHolder, $(e.currentTarget));
      });
    });
  };

  return {
    init,
  };
})();

export default Collection;
